import useDeleteData from '../../../../../hooks/deleteHook';

export const useRemoveLink = (instructionId, linkId) => {
  const [{ data, isLoading, isError, error }, doRemoveLink] = useDeleteData(
    `office_knowledge_base/${instructionId}/link/${linkId}`
  );

  return { data, isLoading, isError, error, doRemoveLink };
};
